import { useState } from "react";
import { Button, Stack } from "@mui/material";
import { Dayjs } from "dayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { readOnlyDateInputProps, readOnlyDateInputSx } from "../datePickerReadOnlyInput";

interface BrandStagesFilterItemsProps {
  initialRange: [Dayjs, Dayjs];
  onGetData: (range: [Dayjs, Dayjs]) => void;
}

// Reported from / Reported until are drafts until GET DATA applies them
// (spec Section 3.1) - picking a date alone doesn't refetch.
export default function BrandStagesFilterItems({ initialRange, onGetData }: BrandStagesFilterItemsProps) {
  const [draftStart, setDraftStart] = useState<Dayjs | null>(initialRange[0]);
  const [draftEnd, setDraftEnd] = useState<Dayjs | null>(initialRange[1]);

  const handleGetData = () => {
    if (draftStart && draftEnd) onGetData([draftStart, draftEnd]);
  };

  return (
    <LocalizationProvider dateAdapter={AdapterDayjs}>
      <Stack direction="row" spacing={2.25} alignItems="center" flexWrap="wrap" useFlexGap>
        <DatePicker
          label="Reported from"
          value={draftStart}
          maxDate={draftEnd ?? undefined}
          format="DD-MM-YYYY"
          enableAccessibleFieldDOMStructure={false}
          onChange={(value) => setDraftStart(value)}
          slotProps={{
            textField: {
              size: "small",
              color: "secondary",
              inputProps: readOnlyDateInputProps,
              sx: { ...readOnlyDateInputSx, width: 200 },
              "data-tracker": "1151",
            } as any,
          }}
        />
        <DatePicker
          label="Reported until"
          value={draftEnd}
          minDate={draftStart ?? undefined}
          format="DD-MM-YYYY"
          enableAccessibleFieldDOMStructure={false}
          onChange={(value) => setDraftEnd(value)}
          slotProps={{
            textField: {
              size: "small",
              color: "secondary",
              inputProps: readOnlyDateInputProps,
              sx: { ...readOnlyDateInputSx, width: 200 },
              "data-tracker": "1152",
            } as any,
          }}
        />
        <Button
          variant="contained"
          color="secondary"
          size="small"
          disableElevation
          onClick={handleGetData}
          disabled={!draftStart || !draftEnd}
          sx={{ height: 40, borderRadius: "4px" }}
          data-tracker="1153"
        >
          Get data
        </Button>
      </Stack>
    </LocalizationProvider>
  );
}
